











































































































import { Component } from "vue-property-decorator";
import request from "@/api/index";
import Base from "@/template/public/Base.vue";
import { Icon, Popup } from "vant";
import { wxChatShare } from "@/common/wechat";
import { wxChatJumpApp } from "@/common/wechatapp";
import { findNameByAppconfig } from "@/common/Utils";
import AppPrompt from "@/components/NewsAppProCmpt.vue";
import CalendarPop from "@/components/Calendar.vue";
import { findNameByWechatAppid } from "@/common/Utils";
@Component({
  components: {
    Icon,
    AppPrompt,
    vanPopup: Popup,
    CalendarPop
  }
})
export default class NewsPagefd extends Base {
  public request = new request();
  private dataInfo: any = {};
  private appConfig: any = {};
  public appId: string = "";
  private isRequestLoaded: boolean = false; //详情是否加载完成
  loadding: boolean = true;
  isShow: boolean = false;
  showCal = false;
  videoInfo: any = {
    contentUrl: "",
    title: "",
    onlineTime: ""
  };
  videoUrl: string = "";
  toDay: string = "";
  wxAppId: any;
  infoList: any = [];
  playingId: number | string = "";
  defImg: any =
    "https://imagecdn.cqliving.com/static/h5zwy/resource/images/noimg/37/4-3@2x.png";
  isFirstIn: boolean = true;
  async mounted() {
    this.appId = (this as any).$route.query.appId || "";
    await this.getShareInfo(this.appId);
    this.wxAppId = findNameByWechatAppid(this.$store.state.appInfo, this.appId);
    if (this.$route.query.time) {
      (this as any).toDay = this.$route.query.time;
    } else {
      let time = new Date();
      let year = time.getFullYear();
      let m: number | string = time.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d: number | string = time.getDate();
      d = d < 10 ? "0" + d : d;
      this.toDay = `${year}-${m}-${d}`;
    }
    (this as any).playingId = this.$route.query.cid
      ? this.$route.query.cid
      : "";
    this.getList(true);
  }
  showCalPop() {
    this.showCal = true;
    this.$nextTick(() => {
      (this as any).$refs.calendar.mymonths = this.toDay.substr(0, 7);
      (this as any).$refs.calendar.getDayAndWeek();
    });
  }
  async getList(bol: boolean = false) {
    let res = await this.request.getNewsList("37", this.toDay);
    this.loadding = false;
    if (res.code == 0) {
      if (this.isFirstIn) {
        this.isRequestLoaded = true;
        this.isFirstIn = false;
      }
      this.infoList = res.data.dataList;
      let appId =
        this.infoList.length > 0
          ? this.infoList[0].appId
          : this.$route.query.appId;
      if (this.infoList.length) {
        this.isShow = true;
        var appInfo = this.$store.state.appInfo;
        this.appConfig = findNameByAppconfig(
          appInfo,
          this.appId || (this.$route.query.appId as string)
        );
        if (bol && this.playingId) {
          let i = 0;
          let chosInfo = this.infoList.filter(
            (item: { id: string | number }, index: number) => {
              if (item.id == this.playingId) {
                i = index;
              }
              return item.id == this.playingId;
            }
          );
          this.videoInfo = chosInfo.length ? chosInfo[0] : this.infoList[0];
          this.playingId = chosInfo.length
            ? chosInfo[0].id
            : this.infoList[0].id;
          this.$nextTick(() => {
            if (this.$refs[`scroll${this.playingId}`]) {
              (this.$refs[`listBox`] as HTMLElement).scrollTop =
                (this.$refs[`scroll${this.playingId}`] as any)[0].offsetHeight *
                i;
            }
          });
        } else {
          this.videoInfo = this.infoList[0];
          this.playingId = this.infoList[0].id;
        }
        this.shareConfig();
      } else {
        this.isShow = false;
      }
    }
  }
  shareConfig() {
    const wechatConfigId = this.appConfig.wechatConfigId;
    const linkUrl = window.location.href;
    const dayArr = this.toDay.split("-");
    const des = `潼南新闻${dayArr[0]}年${dayArr[1]}月${dayArr[2]}日`;
    if (
      linkUrl &&
      this.appConfig.realmUrl &&
      linkUrl.indexOf(this.appConfig.realmUrl) != -1
    ) {
      wxChatJumpApp(
        wechatConfigId,
        this.videoInfo.title,
        des,
        linkUrl,
        this.videoInfo.images
          ? this.videoInfo.images.split(",")[0]
          : "https://imagecdn.cqliving.com/images/icon/37.png"
      );
    } else {
      wxChatShare(
        this.videoInfo.title,
        des,
        linkUrl,
        this.videoInfo.images
          ? this.videoInfo.images.split(",")[0]
          : "https://imagecdn.cqliving.com/images/icon/37.png"
      );
    }
  }
  changeUrl(data: any) {
    this.videoInfo = data;
    this.playingId = data.id;
    this.$nextTick(() => {
      (this.$refs["videoBox"] as HTMLVideoElement).play();
    });
    this.shareConfig();
  }
  changeDate(num: number, val: string) {
    switch (num) {
      case 2:
        this.toDay = val;
        this.getList();
        this.showCal = false;
        break;
      default:
        this.showCal = false;
        break;
    }
  }
}
